module.exports = __webpack_public_path__ + "img/icon_travel.2ab970ba.svg";